import {axios} from "../../../axiosConfig";

const url = "api/admin/v1/email";

export const apiSendMail=(data,callback,error)=>{
    axios.post(url+"/send",data)
        .then(response=>callback(response.data.data))
        .catch(err=>error(err));
}
